module.exports = __webpack_public_path__ + "static/img/active.87baae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/active.png
// module id = XQK1
// module chunks = 0